import React, { useEffect, useState, useRef } from "react";
import * as Accordion from "@radix-ui/react-accordion";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import {
  FaPlusCircle,
  FaSave,
  FaUpload,
  FaSortUp,
  FaSortDown,
  FaEllipsisV,
  FaCalendarAlt,
  FaLink,
  FaTrash,
  FaPaperPlane,
  FaTimes,
  FaEnvelope,
} from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { fetchChurches, backupChurches, restoreChurches } from '../../API/churchesApi';
import { addChurch } from '../../API/addChurch';
import { deleteChurches } from '../../API/deleteChurchAPI';





import * as Tooltip from '@radix-ui/react-tooltip';

import { ChurchInfo } from './MapsDropDownMenu';
import { LuMessageCircle, LuMail } from 'react-icons/lu';
import * as AlertDialog from '@radix-ui/react-alert-dialog';





const handleBackupChurches = async () => {
  try {
    const response = await backupChurches();
    const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = 'churches_backup.xlsx';
    link.click();
  } catch (error) {
    console.error('Error backing up churches:', error);
  }
};






const AdminPage = () => {
  const [churches, setChurches] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedChurches, setSelectedChurches] = useState([]);
  const fileInputRef = useRef(null);
  const allChurchesSelected =
    selectedChurches.length === churches.length && churches.length > 0;
  const [visibleColumns, setVisibleColumns] = useState([
    "name",
    "stateCity",
    "lastUpdated",
    "updatedBy",
  ]);
  const [mobileColumn, setMobileColumn] = useState("name");
  const [dateFilter, setDateFilter] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [activeFilter, setActiveFilter] = useState(null);
  const [expandedRows, setExpandedRows] = useState([]);
  const [expandedRow, setExpandedRow] = useState(null);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);


  const updateChurchInState = (updatedChurch) => {
    setChurches(prevChurches => prevChurches.map(church => 
      church.id === updatedChurch.id ? { ...church, ...updatedChurch } : church
    ));
  };
  

  const DeleteConfirmationDialog = ({ isOpen, onClose, onConfirm, count }) => (
    <AlertDialog.Root open={isOpen} onOpenChange={onClose}>
      <AlertDialog.Portal>
        <AlertDialog.Overlay className="fixed inset-0 bg-black/50" />
        <AlertDialog.Content className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg p-6 max-w-md w-full">
          <AlertDialog.Title className="text-lg font-bold mb-4">Confirm Deletion</AlertDialog.Title>
          <AlertDialog.Description className="mb-4">
            Are you sure you want to delete {count} {count === 1 ? 'church' : 'churches'}? This action cannot be undone.
          </AlertDialog.Description>
          <div className="flex justify-end space-x-4">
            <AlertDialog.Cancel asChild>
              <button className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300">Cancel</button>
            </AlertDialog.Cancel>
            <AlertDialog.Action asChild>
              <button onClick={onConfirm} className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600">Delete</button>
            </AlertDialog.Action>
          </div>
        </AlertDialog.Content>
      </AlertDialog.Portal>
    </AlertDialog.Root>
  );
   
  const handleChurchDeletion = (deletedChurchId) => {
    setChurches(prevChurches => prevChurches.filter(church => church.id !== deletedChurchId));
  };
  
  const handleBulkDelete = async () => {
    setIsDeleteDialogOpen(true);
  };
  
  const confirmDelete = async () => {
    try {
      await deleteChurches(selectedChurches);
      handleDeleteSuccess(selectedChurches);
      setIsDeleteDialogOpen(false);
    } catch (error) {
      console.error('Error deleting churches:', error);
      // Handle error (e.g., show error message to user)
    }
  };

  const handleDeleteSuccess = (deletedChurchIds) => {
    const idsToDelete = Array.isArray(deletedChurchIds) ? deletedChurchIds : [deletedChurchIds];
    setChurches(prevChurches => prevChurches.filter(church => !idsToDelete.includes(church.id)));
    setSelectedChurches([]);
  };
  
  
const handleCloseRow = () => {
  setExpandedRow(null);
};


  const handleAddChurch = async () => {
    const newChurch = {
        name: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        mailing_address: '',
        mailing_city: '',
        mailing_state: '',
        mailing_zip: '',
        lat: null,
        lon: null,
        sunday_am: null,
        sunday_pm: null,
        midweek: '',
        contact1_name: '',
        contact1_phone: '',
        contact1_email: '',
        contact1_token: '',
        contact1_token_expires_at: null,
        contact1_last_updated: null,
        contact2_name: '',
        contact2_phone: '',
        contact2_email: '',
        contact2_token: '',
        contact2_token_expires_at: null,
        contact2_last_updated: null,
        contact3_name: '',
        contact3_phone: '',
        contact3_email: '',
        contact3_token: '',
        contact3_token_expires_at: null,
        contact3_last_updated: null,
        website: '',
        facebook_link: '',
        notes: '',
        contact1_public: true,
        contact2_public: true,
        contact3_public: true,
        contact1_display_email: true,
        contact1_display_phone: true,
        contact2_display_email: true,
        contact2_display_phone: true,
        contact3_display_email: true,
        contact3_display_phone: true,
        last_updated_by: '',
        last_update_ip: '',
        update_count: 0,
        preferred_contact_method: '',
        is_active: true,
        data_verified_at: null,
        contact1_preferred_email: false,
        contact1_preferred_text: false,
        contact1_preferred_call: false,
        contact2_preferred_email: false,
        contact2_preferred_text: false,
        contact2_preferred_call: false,
        contact3_preferred_email: false,
        contact3_preferred_text: false,
        contact3_preferred_call: false
    };

    try {

      const response = await addChurch(newChurch);
      if (response.success) {
          const newChurchData = response.church;
          setChurches(prevChurches => {
            const newChurches = [newChurchData, ...prevChurches];

            return newChurches;
          });
          
          setExpandedRow(newChurchData.id.toString());
          setSortConfig({ key: null, direction: 'ascending' });
      } else {
          console.error(response.message);
      }
  } catch (error) {
      console.error('Error adding church:', error);
  }
};

  const handleRestoreChurches = async () => {
    if (fileInputRef.current.files[0]) {
      try {
        const formData = new FormData();
        formData.append('backup', fileInputRef.current.files[0]);
        const response = await restoreChurches(formData);
  
        // Reload churches data after successful restore
        const updatedChurches = await fetchChurches();
        setChurches(updatedChurches);
  
        // Reset sorting and filtering
        setSortConfig({ key: null, direction: 'ascending' });
        setSearchTerm('');
  
        // Show success message
        alert('Churches restored successfully. The list has been updated.');
      } catch (error) {
        console.error('Error restoring churches:', error);
        alert('Error restoring churches. Please try again.');
      }
    }
  };
  
  const applyDateFilter = (type, date, endDate = null) => {
    setDateFilter({ type, date, endDate });
    setIsDatePickerOpen(false);
    setActiveFilter(
      `${type}: ${date.toLocaleDateString()}${
        endDate ? ` - ${endDate.toLocaleDateString()}` : ""
      }`
    );
  };

  const clearDateFilter = () => {
    setDateFilter(null);
    setStartDate(null);
    setEndDate(null);
    setActiveFilter(null);
  };

  useEffect(() => {
    const loadChurches = async () => {
      try {
        const data = await fetchChurches();
        setChurches(data);
      } catch (error) {
        console.error("Error loading churches:", error);
      }
    };
    loadChurches();
  }, []);

  const sortedChurches = [...churches]
  .filter((church) => {
    const search = searchTerm.toLowerCase();

    // Include all churches when search term is empty
    if (search === "") return true;

    // Check if any of the fields contain the search term
    return (
      (church.name && church.name.toLowerCase().includes(search)) ||
      (church.city && church.city.toLowerCase().includes(search)) ||
      (church.state && church.state.toLowerCase().includes(search))
    );
  })
  .sort((a, b) => {
    if (sortConfig.key === null) return 0;
    const direction = sortConfig.direction === "ascending" ? 1 : -1;

    if (sortConfig.key === "stateCity") {
      const stateComparison = (a.state || "").localeCompare(b.state || "");
      if (stateComparison !== 0) return stateComparison * direction;
      return (a.city || "").localeCompare(b.city || "") * direction;
    } else if (sortConfig.key === "lastUpdated") {
      const dateA = new Date(a.updated_at);
      const dateB = new Date(b.updated_at);
      if (isNaN(dateA) && isNaN(dateB)) return 0;
      if (isNaN(dateA)) return -1 * direction;
      if (isNaN(dateB)) return 1 * direction;
      return (dateA - dateB) * direction;
    } else if (sortConfig.key === "updatedBy") {
      return (
        (a.last_updated_by || "").localeCompare(b.last_updated_by || "") *
        direction
      );
    } else {
      return (
        (a[sortConfig.key] || "").localeCompare(b[sortConfig.key] || "") *
        direction
      );
    }
  });


  const requestSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const getSortArrow = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === "ascending" ? (
        <FaSortUp />
      ) : (
        <FaSortDown />
      );
    }
    return null;
  };

  const handleRestore = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const toggleChurchSelection = (churchId, event) => {
    // Prevent the event from bubbling up to the accordion
    event.stopPropagation();

    setSelectedChurches((prevSelected) =>
      prevSelected.includes(churchId)
        ? prevSelected.filter((id) => id !== churchId)
        : [...prevSelected, churchId]
    );
  };

  const toggleSelectAll = () => {
    if (allChurchesSelected) {
      setSelectedChurches([]);
    } else {
      setSelectedChurches(churches.map((church) => church.id));
    }
  };

  const isSelected = (churchId) => selectedChurches.includes(churchId);

  const toggleColumnVisibility = (column) => {
    setVisibleColumns((prev) =>
      prev.includes(column)
        ? prev.filter((col) => col !== column)
        : [...prev, column]
    );
  };

  const filteredChurches = sortedChurches.filter((church) => {
    if (!dateFilter) return true;
    const updatedDate = new Date(church.updated_at);
    switch (dateFilter.type) {
      case "before":
        return updatedDate < dateFilter.date;
      case "after":
        return updatedDate > dateFilter.date;
      case "range":
        return (
          updatedDate >= dateFilter.date && updatedDate <= dateFilter.endDate
        );
      default:
        return true;
    }
  });




  const DateFilterComponent = () => {
    const [filterType, setFilterType] = useState("range");
    const datePickerRef = useRef(null);

    const handleDatePickerClick = (e) => {
      e.stopPropagation();
    };

    const handleFilterTypeChange = (e) => {
      e.stopPropagation();
      setFilterType(e.target.value);
    };

    const handleDateChange = (date) => {
      if (filterType === "range") {
        if (!startDate) {
          setStartDate(date);
        } else if (!endDate) {
          setEndDate(date);
        }
      } else {
        setStartDate(date);
        // Automatically apply the filter for 'before' and 'after'
        applyDateFilter(filterType, date);
      }
    };

    return (
      <div
        className="relative"
        ref={datePickerRef}
        onClick={handleDatePickerClick}
      >
        <button
          onClick={() => setIsDatePickerOpen(!isDatePickerOpen)}
          className="flex items-center bg-blue-500 text-white px-4 py-2 rounded-lg shadow hover:bg-blue-600 transition-colors"
        >
          <FaCalendarAlt className="mr-2 md:mr-0" />
          <span className="hidden md:inline ml-2">Date Filter</span>
        </button>
        {isDatePickerOpen && (
          <div className="absolute right-0 md:right-auto md:left-0 top-full mt-2 z-50 md:w-80">
            <div className="bg-white rounded-md shadow-lg p-6 w-screen md:w-full max-w-[320px] mx-auto md:mx-0">
              <h3 className="text-lg font-semibold mb-4">Filter by Date</h3>
              <div className="space-y-4">
                <div>
                  <select
                    value={filterType}
                    onChange={handleFilterTypeChange}
                    className="w-full border border-gray-300 rounded-md shadow-sm px-3 py-2"
                  >
                    <option value="range">Date Range</option>
                    <option value="before">Before</option>
                    <option value="after">After</option>
                  </select>
                </div>
                {filterType === "range" && (
                  <>
                    <DatePicker
                      selected={startDate}
                      onChange={handleDateChange}
                      selectsStart
                      startDate={startDate}
                      endDate={endDate}
                      placeholderText="Start Date"
                      className="w-full border border-gray-300 rounded-md shadow-sm px-3 py-2"
                    />
                    <DatePicker
                      selected={endDate}
                      onChange={handleDateChange}
                      selectsEnd
                      startDate={startDate}
                      endDate={endDate}
                      minDate={startDate}
                      placeholderText="End Date"
                      className="w-full border border-gray-300 rounded-md shadow-sm px-3 py-2"
                    />
                  </>
                )}
                {(filterType === "before" || filterType === "after") && (
                  <DatePicker
                    selected={startDate}
                    onChange={handleDateChange}
                    placeholderText={
                      filterType === "before" ? "Before Date" : "After Date"
                    }
                    className="w-full border border-gray-300 rounded-md shadow-sm px-3 py-2"
                  />
                )}
                <div className="flex space-x-2">
                  <button
                    onClick={() =>
                      applyDateFilter(filterType, startDate, endDate)
                    }
                    className="flex-1 bg-blue-500 text-white px-3 py-2 rounded-md hover:bg-blue-600 transition-colors"
                  >
                    Apply Filter
                  </button>
                  <button
                    onClick={clearDateFilter}
                    className="flex-1 bg-red-500 text-white px-3 py-2 rounded-md hover:bg-red-600 transition-colors"
                  >
                    Clear Filter
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  const ColumnSelectionMenu = ({ selectedCount }) => (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button className="text-gray-600 absolute right-2 top-2">
          <FaEllipsisV />
        </button>
      </DropdownMenu.Trigger>

      <DropdownMenu.Content className="bg-white rounded-md shadow-lg p-2">
        {["name", "stateCity", "lastUpdated", "updatedBy"].map((column) => (
          <DropdownMenu.RadioItem
            key={column}
            value={column}
            onSelect={() => setMobileColumn(column)}
            className="flex items-center px-2 py-1 text-sm"
          >
            <DropdownMenu.ItemIndicator className="mr-2">
              {mobileColumn === column && "✓"}
            </DropdownMenu.ItemIndicator>
            {column}
          </DropdownMenu.RadioItem>
        ))}

        {selectedCount > 0 && (
          <>
            <hr className="my-2 border-t-2 border-gray-500" />
            <DropdownMenu.Separator className="my-1 border-t border-gray-200" />
            <DropdownMenu.Item
              className="flex items-center px-2 py-1 text-sm"
              onSelect={() => handleSave()}
            >
              <FaSave className="mr-2" /> Save
            </DropdownMenu.Item>
            <DropdownMenu.Item
              className="flex items-center px-2 py-1 text-sm"
              onSelect={() => handleSendLinks()}
            >
              <FaLink className="mr-2" /> Send Links
            </DropdownMenu.Item>
            <DropdownMenu.Item
  className="flex items-center px-2 py-1 text-sm text-red-600"
  onSelect={() => handleBulkDelete()}
>
  <FaTrash className="mr-2" /> Delete
</DropdownMenu.Item>
          </>
        )}
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
  const MobileColumnHeader = () => (
    <button
      onClick={() => requestSort(mobileColumn)}
      className="flex items-center justify-between w-full pr-10"
    >
      <span>
        {mobileColumn === "name" && "Church Name"}
        {mobileColumn === "stateCity" && "State/City"}
        {mobileColumn === "lastUpdated" && "Last Updated"}
        {mobileColumn === "updatedBy" && "Updated By"}
      </span>
      {/* <span className="mr-6">{getSortArrow(mobileColumn)}</span> */}
    </button>
  );

  const ActiveFilterTag = () => {
    if (!activeFilter) return null;
    return (
      <div className="inline-flex items-center bg-blue-100 text-blue-800 rounded-full px-2 py-1 text-xs md:text-sm">
        {activeFilter}
        <button
          onClick={clearDateFilter}
          className="ml-1 text-blue-600 hover:text-blue-800"
        >
          ×
        </button>
      </div>
    );
  };

  const ActionButtons = ({ selectedCount }) => {
    if (selectedCount === 0) return null;

    return (
      <div className="flex items-center justify-between w-full">
        <div className="flex items-center space-x-2">
          <button className="bg-blue-500 text-white p-2 rounded hover:bg-blue-600">
            <FaSave />
          </button>
          <button className="bg-yellow-500 text-white p-2 rounded hover:bg-green-600">
            <FaPaperPlane />
          </button>
        </div>
        <button className="bg-red-500 text-white p-2 rounded hover:bg-red-600">
          <FaTrash />
        </button>
      </div>
    );
  };

  const handleSave = () => {
    // Implement save functionality
  };

  const handleSendLinks = () => {
    // Implement send links functionality
  };

  const handleDelete = () => {
    // Implement delete functionality

  };



  return (
    <div className="bg-gray-100 py-10 px-8">
      <div className="max-w-7xl mx-auto mb-0">
        <div className="flex justify-between items-center mb-1">
          <h2 className="text-3xl font-bold text-gray-700">
            Church Management
          </h2>

          <div className="flex space-x-4">
          <button 
  className="flex items-center space-x-2 bg-blue-500 text-white px-4 py-2 rounded-lg shadow hover:bg-blue-600 transition-colors"
  onClick={handleAddChurch}
>
  <FaPlusCircle />
  <span className="hidden md:inline">Add Church</span>
</button>


            <button 
  className="flex items-center space-x-2 bg-green-500 text-white px-4 py-2 rounded-lg shadow hover:bg-green-600 transition-colors"
  onClick={handleBackupChurches}
>
  <FaSave />
  <span className="hidden md:inline">Backup</span>
</button>

<button
  className="flex items-center space-x-2 bg-yellow-500 text-white px-4 py-2 rounded-lg shadow hover:bg-yellow-600 transition-colors"
  onClick={() => fileInputRef.current.click()}
>
  <FaUpload />
  <span className="hidden md:inline">Restore</span>
</button>

<input
  type="file"
  ref={fileInputRef}
  style={{ display: "none" }}
  accept=".xlsx"
  onChange={handleRestoreChurches}
/>

          </div>
        </div>

        <div className="max-w-7xl mx-auto mb-6">
  <div className="flex flex-col space-y-4">
    <div className="flex items-center justify-between">
      <div className="flex items-center space-x-2 md:space-x-4 w-full">
        <input
          type="text"
          placeholder="Search churches..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="border border-gray-300 rounded-lg px-4 py-2 w-full md:w-auto"
        />
        <div className="md:hidden">
          <DateFilterComponent />
        </div>
        <div className="hidden md:flex items-center space-x-2">
          <DateFilterComponent />
          <Tooltip.Provider>
            <div
              className={`${
                selectedChurches.length > 0 ? "visible" : "invisible"
              }`}
            >
              {/* <Tooltip.Root>
                <Tooltip.Trigger asChild>
                  <button className="bg-blue-500 text-white p-2 rounded hover:bg-blue-600 mr-2">
                    <FaSave />
                  </button>
                </Tooltip.Trigger>
                <Tooltip.Content className="bg-gray-800 text-white text-xs rounded px-2 py-1">
                  Save
                </Tooltip.Content>
              </Tooltip.Root> */}
              <Tooltip.Root>
                <Tooltip.Trigger asChild>
                  <button className="bg-yellow-500 text-white p-2 rounded hover:bg-yellow-600">
                    <FaPaperPlane />
                  </button>
                </Tooltip.Trigger>
                <Tooltip.Content className="bg-gray-800 text-white text-xs rounded px-2 py-1">
                  Send Link
                </Tooltip.Content>
              </Tooltip.Root>
            </div>
          </Tooltip.Provider>
        </div>
      </div>
      <Tooltip.Provider>
        <div
          className={`hidden md:block ${
            selectedChurches.length > 0 ? "visible" : "invisible"
          }`}
        >
<Tooltip.Root>
  <Tooltip.Trigger asChild>
    <button 
      className="bg-red-500 text-white p-2 rounded hover:bg-red-600"
      onClick={handleBulkDelete}
    >
      <FaTrash />
    </button>
  </Tooltip.Trigger>
  <Tooltip.Content className="bg-gray-800 text-white text-xs rounded px-2 py-1">
    Delete
  </Tooltip.Content>
</Tooltip.Root>

        </div>
      </Tooltip.Provider>
    </div>
  </div>
</div>

        <div className="mt-2 md:mt-0 md:ml-4 md:inline-block">
          <ActiveFilterTag />
        </div>
      </div>
      <div className="max-w-7xl mx-auto bg-white shadow-lg rounded-lg mb-4">
        <div className="relative grid grid-cols-[auto,1fr] md:grid-cols-[auto,1fr,1fr,1fr,1fr] items-center bg-gray-200 p-2 rounded-t-lg text-sm font-semibold text-gray-700">
          <div className="flex items-center text-sm font-semibold text-gray-700">
            <input
              type="checkbox"
              className="h-3 w-3"
              checked={allChurchesSelected}
              onChange={toggleSelectAll}
            />
          </div>
          <div className="md:hidden">
            <MobileColumnHeader />
          </div>
          <button
            onClick={() => requestSort("name")}
            className="hidden md:flex items-center text-sm font-semibold text-gray-700"
          >
            Church Name {getSortArrow("name")}
          </button>
          <button
            onClick={() => requestSort("stateCity")}
            className="hidden md:flex items-center justify-start"
          >
            State/City {getSortArrow("stateCity")}
          </button>
          <button
            onClick={() => requestSort("lastUpdated")}
            className="hidden md:flex items-center text-sm font-semibold text-gray-700 justify-end"
          >
            Last Updated {getSortArrow("lastUpdated")}
          </button>
          <button
            onClick={() => requestSort("updatedBy")}
            className="hidden md:flex items-center text-sm font-semibold text-gray-700 justify-end"
          >
            Updated By {getSortArrow("updatedBy")}
          </button>

          <div className="md:hidden">
            <ColumnSelectionMenu selectedCount={selectedChurches.length} />
          </div>
        </div>

        {/* Hide action buttons on mobile */}

        <Accordion.Root type="single" value={expandedRow} onValueChange={setExpandedRow} className="space-y-2">
  {filteredChurches.map((church) => (
    <Accordion.Item
      key={church.id}
      value={church.id.toString()}
      className="border-b border-gray-200"
    >
      <Accordion.Header>
      <Accordion.Trigger
  className={`w-full grid grid-cols-[auto,1fr] md:grid-cols-[auto,1fr,1fr,1fr,1fr] items-center text-left text-xs font-normal transition-colors px-2 py-2 ${
    expandedRow === church.id.toString() 
      ? 'bg-[#2c3e50] text-white hover:!bg-[#34495e]' 
      : 'bg-white hover:!bg-gray-100'
  }`}
>
          <input
            type="checkbox"
            className="h-3 w-3 mr-2"
            checked={isSelected(church.id)}
            onChange={(e) => toggleChurchSelection(church.id, e)}
            onClick={(e) => e.stopPropagation()}
          />
          <span className="md:hidden">
            {mobileColumn === "name" && <strong>{church.name}</strong>}
            {mobileColumn === "stateCity" && (
              <>
                <strong>{church.state}</strong> {church.city}
              </>
            )}
            {mobileColumn === "lastUpdated" &&
              new Date(church.updated_at).toLocaleString()}
            {mobileColumn === "updatedBy" &&
              (church.last_updated_by || "Unknown")}
          </span>
          <span className="hidden md:block truncate">
            <strong>{church.name}</strong>
          </span>
          <span className="hidden md:block truncate text-left">
            <strong>{church.state}</strong> {church.city}
          </span>
          <span className="hidden md:block truncate text-right">
            {new Date(church.updated_at).toLocaleString()}
          </span>
          <span className="hidden md:block truncate text-right">
            {church.last_updated_by || "Unknown"}
          </span>
        </Accordion.Trigger>
      </Accordion.Header>
      <Accordion.Content>
      <ChurchInfo 
  church={church} 
  onDeleteSuccess={handleDeleteSuccess} 
  onCloseRow={handleCloseRow}
  updateChurchInState={updateChurchInState}
/>




      </Accordion.Content>
    </Accordion.Item>
  ))}
</Accordion.Root>

      </div>
      <DeleteConfirmationDialog
      isOpen={isDeleteDialogOpen}
      onClose={() => setIsDeleteDialogOpen(false)}
      onConfirm={confirmDelete}
      count={selectedChurches.length}
    />
    </div>
  );
};
export default AdminPage;
